import { render, staticRenderFns } from "./changelog.vue?vue&type=template&id=8c4bb02c&"
import script from "./changelog.vue?vue&type=script&lang=js&"
export * from "./changelog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports